import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { enviarLeadNegocio } from "../api";

export default function PromoRewardsCard({
  title = "¿Tienes un negocio?",
  subtitle = "Regístralo en la app y permite que cientos de usuarios sepan de tí.",
  ctaText = "Presiona para continuar",
  image = "/assets/images/promo.svg", 
  onClick,                       
}) {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [ok, setOk] = useState(false);
  const formRef = useRef(null);
  const hiddenKey = "promo_rewards_hidden_until";

  useEffect(() => {
    const hiddenUntil = Number(localStorage.getItem(hiddenKey) || 0);
    if (!hiddenUntil || Date.now() >= hiddenUntil) {
      setVisible(true);
      localStorage.removeItem(hiddenKey);
    }
  }, []);

  function handleClose() {
    localStorage.setItem(hiddenKey, String(Date.now() + 24 * 60 * 60 * 1000));
    setVisible(false);
    setOpen(false);
  }

  function handleCta() {
    try { if (onClick) onClick(); } catch (e) {}
    setOpen(true);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!formRef.current) return;

    const fd = new FormData(formRef.current);
    const nombre_persona = (fd.get("nombre_persona") || "").toString().trim();
    const nombre_comercio = (fd.get("nombre_comercio") || "").toString().trim();
    const telefono = (fd.get("telefono") || "").toString().trim();
    const mensaje = (fd.get("mensaje") || "").toString().trim();

    if (!nombre_persona || !nombre_comercio || !telefono) {
      alert("Por favor completa nombre, comercio y teléfono.");
      return;
    }
    try {
      setEnviando(true);
      await enviarLeadNegocio({ nombre_persona, nombre_comercio, telefono, mensaje });
      setOk(true);
      setTimeout(() => {
        setOpen(false);
        setOk(false);
        formRef.current && formRef.current.reset();
      }, 1200);
    } catch (err) {
      alert("No pudimos enviar tu solicitud. Intenta de nuevo.");
    } finally {
      setEnviando(false);
    }
  }

  if (!visible) return null;

  return (
    <div className="prc-floating" role="region" aria-label="Programa de recompensas">
      <button className="prc-floating__close" type="button" onClick={handleClose} aria-label="Cerrar promoción">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>

      <button type="button" className="prc-floating__content" onClick={handleCta}>
        <div className="prc-floating__art">
          <img src="/assets/images/logo192.png" alt="" aria-hidden="true" />
        </div>
        <div className="prc-floating__copy">
          <span className="prc-floating__eyebrow">{title}</span>
          <p className="prc-floating__sub">{subtitle}</p>
          <span className="prc-floating__pill">Más información</span>
        </div>
      </button>

      {/* Bottom Sheet */}
      {open && createPortal(
        <div className="bts-backdrop" onClick={() => !enviando && setOpen(false)}>
          <div className="bts-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="bts-handle" />
            <h4 className="bts-title">Ingresa tus datos y nos pondremos en contacto.</h4>

            {!ok ? (
              <form ref={formRef} onSubmit={handleSubmit} className="bts-form">
                <label className="bts-label">
                  Nombre y apellido*
                  <input name="nombre_persona" type="text" className="bts-input" placeholder="Tu nombre" required />
                </label>

                <label className="bts-label">
                  Nombre del comercio*
                  <input name="nombre_comercio" type="text" className="bts-input" placeholder="Ej. Café Central" required />
                </label>

                <label className="bts-label">
                  Teléfono*
                  <input name="telefono" type="tel" className="bts-input" placeholder="+503 7777-7777" required />
                </label>

                <label className="bts-label">
                  Mensaje (opcional)
                  <textarea name="mensaje" rows="3" className="bts-textarea" placeholder="Contanos brevemente sobre tu negocio"></textarea>
                </label>

                <button className="bts-btn" type="submit" disabled={enviando}>
                  {enviando ? "Enviando..." : "Enviar solicitud"}
                </button>
              </form>
            ) : (
              <div className="bts-ok">¡Gracias! Recibimos tu solicitud.</div>
            )}
          </div>
        </div>,
        document.body
      )}

      <style>{`
  .prc-floating{
    position:fixed;
    left:15px;
    right:15px;
    bottom:88px;
    z-index:9999;
    border-radius:26px;
    background: #5a9bd6;
    overflow:hidden;
  }
  .prc-floating__close{
    position:absolute;
    top:12px;
    right:12px;
    width:34px;
    height:34px;
    border:none;
    border-radius:999px;
    background:rgba(255,255,255,0.14);
    color:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
    z-index:2;
    backdrop-filter: blur(6px);
  }
  .prc-floating__content{
    width:100%;
    display:flex;
    align-items:center;
    gap:14px;
    border:none;
    background:transparent;
    color:#fff;
    padding:10px 0px 10px;
    text-align:left;
    cursor:pointer;
  }
  .prc-floating__art{
    width:60px;
    height:60px;
    border-radius:22px;
    display:flex;
    align-items:center;
    justify-content:center;
    overflow:hidden;
  }
  .prc-floating__art img{
    width:70%;
    height:70%;
    object-fit:contain;
    display:block;
  }
  .prc-floating__copy{
    flex:1;
    min-width:0;
    padding-right:34px;
  }
  .prc-floating__eyebrow{
    display:block;
    margin-bottom:4px;
    font-size:13px;
    font-weight:800;
    opacity:.9;
    letter-spacing:.02em;
  }
  .prc-floating__title{
    margin:0;
    font-size:25px;
    line-height:1.05;
    font-weight:900;
    color:#fff;
  }
  .prc-floating__sub{
    margin:8px 0 12px;
    font-size:14px;
    line-height:1.25;
    color:rgba(255,255,255,.9);
  }
  .prc-floating__pill{
    display:inline-flex;
    align-items:center;
    min-height:25px;
    border-radius:25px;
    padding:5px 12px;
    background:#000;
    color:#fff;
    font-weight:500;
    font-size:13px;
    box-shadow:0 8px 16px rgba(0,0,0,.14);
  }

  @media (max-width: 560px){
    .prc-floating{
      bottom:82px;
      border-radius:22px;
    }
    .prc-floating__content{
      padding:15px 14px 14px;
    }
    .prc-floating__art{
      width:60px;
      height:60px;
      border-radius:18px;
    }
    .prc-floating__title{
      font-size:20px;
    }
    .prc-floating__sub{
      font-size:13px;
      margin-bottom:10px;
    }
  }

  .bts-backdrop{
    position:fixed; inset:0; background:rgba(0,0,0,.35);
    z-index:99999999;
    display:flex; align-items:flex-end; justify-content:center;
    box-sizing: border-box;
  }
  .bts-sheet{
    width:100%; max-width:640px; background:#fff; border-top-left-radius:18px; border-top-right-radius:18px;
    padding:16px 16px 20px; box-shadow:0 -6px 20px rgba(0,0,0,.15);
    animation:bts-slide .22s ease-out;
  }
  @keyframes bts-slide { from{ transform:translateY(14px); opacity:.95; } to{ transform:translateY(0); opacity:1; } }
  .bts-handle{ width:48px; height:5px; background:#e5e5e5; border-radius:999px; margin:6px auto 10px; }
  .bts-title{ margin:10px 0 25px; font-size:15px; font-weight:700; }
  .bts-form{ display:flex; flex-direction:column; gap:10px; }
  .bts-label{ display:flex; flex-direction:column; font-size:13px; font-weight:700; gap:6px; }
  .bts-input, .bts-textarea{
    width:100%; border:1px solid #e6e6e6; border-radius:10px; padding:10px 12px; font-size:14px;
    outline:none;
  }
  .bts-input:focus, .bts-textarea:focus{ border-color:#81a54e; box-shadow:0 0 0 3px rgba(129,165,78,.15); }
  .bts-btn{
    margin-top:6px; border:0; border-radius:12px; padding:11px 14px; font-weight:800; font-size:15px;
    background:#000; color:#fff; cursor:pointer;
  }
  .bts-btn[disabled]{ opacity:.6; cursor:default; }
  .bts-ok{
    padding:24px 6px 28px; text-align:center; font-weight:800; font-size:16px;
  }
  
`}</style>

    </div>
  );
}
